module.exports = __webpack_public_path__ + "img/hot.2a8c6b96.svg";